import React from "react";
import { HiLockClosed, HiOutlineXMark } from "react-icons/hi2";
export const Input = ({ label, type, onChange, value, name, disabled,maxlength,min,max,placeholder, onClear, showClear, onFocus, onBlur, onKeyDown, inputMode }) => {

  const onPressClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange({ target: { name: name, value: "" } });
    }
  }

  return (
    <div className="relative mb-2">
      {" "}
      {/* Add "mb-4" for margin-bottom */}
      <label className="text-gray-500 text-xs font-medium uppercase tracking-wider px-1 left-2 -top-2">
        {label}  {disabled?<HiLockClosed className="inline"/>:""}
      </label>
      <div className="relative">
        <input
          autoComplete="off"
          value={value}
          placeholder={placeholder}
          min={min}
          max={max}
          maxLength={maxlength}
          className={`rounded-md h-10 p-2 pl-2 w-full focus:outline-success-200 ${disabled ? "border-2 " : "border-primary-300 border border-gray-300"} ${showClear && value ? "pr-8" : ""}`}
          type={type}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          inputMode={inputMode}
          name={name}
          disabled={disabled}
        />
        {showClear && value && !disabled && (
          <button
            type="button"
            onClick={onPressClear}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <HiOutlineXMark className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};
